import StyledAllInclusiveAlert from './StyledAllInclusiveAlert'
export default StyledAllInclusiveAlert
